<template>
  <header class="caja-header">
    <div class="izq">
      <div class="eyebrow">{{ eyebrow }}</div>
      <h1 class="titulo">
        {{ titulo }}
        <span v-if="sucursal" class="sucursal">
          <v-icon small color="#9a9a9a">mdi-map-marker</v-icon>
          {{ sucursal }}
        </span>
      </h1>
      <div class="detalle" v-if="$slots.default">
        <slot></slot>
      </div>
    </div>
    <div class="der">
      <div class="hora">{{ horaActual }}</div>
      <div class="fecha">{{ fechaActual }}</div>
      <slot name="acciones"></slot>
    </div>
  </header>
</template>

<script>
// Cabecera común de las pantallas del flujo de caja (sucursal → caja →
// apertura → cierre): qué se está haciendo, dónde, y la hora.
export default {
  name: "CajaHeader",
  props: {
    eyebrow: { type: String, required: true },
    titulo: { type: String, required: true },
    sucursal: { type: String, default: "" },
  },
  data() {
    return { ahora: new Date(), reloj: null };
  },
  computed: {
    horaActual() {
      return this.moment(this.ahora).format("HH:mm");
    },
    fechaActual() {
      return this.moment(this.ahora).format("dddd D [de] MMMM");
    },
  },
  created() {
    this.reloj = setInterval(() => (this.ahora = new Date()), 1000);
  },
  beforeDestroy() {
    clearInterval(this.reloj);
  },
};
</script>

<style scoped>
.caja-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 14px;
}
.eyebrow {
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #BA6B30;
  font-weight: 700;
}
.titulo {
  font-size: 34px;
  font-weight: 700;
  line-height: 1.15;
  margin: 2px 0 8px;
  color: #fff;
}
.sucursal {
  font-size: 16px;
  font-weight: 400;
  color: #9a9a9a;
  margin-left: 10px;
  white-space: nowrap;
}
.detalle {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #cfcfcf;
  font-size: 15px;
}
.der {
  text-align: right;
  flex-shrink: 0;
}
.hora {
  font-size: 30px;
  font-weight: 300;
  color: #fff;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}
.fecha {
  color: #8a8a8a;
  font-size: 14px;
  text-transform: capitalize;
}
</style>
